import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Checkbox,
    Space,
    Tabs,
  } from "antd";
  import axios from "axios";
  import React, { Component } from "react";
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  import { connect } from "react-redux";
  // import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
  import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    RangePickerItem,
    TableItem,
    dineroDisabledMask,
    ButtonItem,
    ErrorItem,
    round2Decimals
  } from "../../../../Components/Items";
  import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
  import * as XLSXStyle from "xlsx-js-style";
  import { ResponsiveLine } from "@nivo/line";
  import moment from "moment";
  import "moment/locale/es";
    import reporteDeComprasPdf from "../../../../Pdf/reporteDeComprasPdf";
  moment.locale("es");
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
  const { Option } = Select;
  const { TabPane } = Tabs;
  
  class ReporteCompras extends Component {
    state = {
      loading: false,
      pdf: null,
      objetoProveedores: null,
      todasProveedores: null,
      objetoProyectos: null,
      todasProyectos: null,
      objetoUniadesDeNegocio: null,
      todasUniadesDeNegocio: null,
      objetoSubProyectos: null,
      todasSubProyectos: null,
      objetoTiposProveedor: null,
      dataReporte: null,
      todasCompras: [],
      dataGrafico: [],
      subtotal: 0,
      totalImpuestos: 0,
      total: 0,
      totalRetenciones: 0,
      totalAPagar: 0,
      desglosarProductos: false
    };
  
    atras() {
        this.props.history.goBack();
    }
  
    async componentDidMount() {
      this.setState({ loading: true });
      await axios
        .post(
          "proveedores/selectProveedores",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProveedores: res.data });
            this.setState({
              objetoProveedores: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "usuarios/selectUsuariosEmpresa",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUsuarios: res.data });
            this.setState({
              objetoUsuarios: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre +
                      " " +
                      value.apellidoPaterno +
                      " " +
                      value.apellidoMaterno}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasUniadesDeNegocio: res.data });
            this.setState({
              objetoUniadesDeNegocio: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {cuentaMask(
                      value.nivel1 +
                        value.nivel2 +
                        value.nivel3 +
                        value.nivel4 +
                        value.nivel5
                    ) +
                      " - " +
                      value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      // Catalogo completo de subproyectos de la empresa: el filtro no depende de la
      // pestana Proyecto. Ojo, este endpoint no devuelve un arreglo pelon como
      // selectProyectos, sino { success: 2, subProyectos }.
      await axios
        .post(
          "subProyectos/selectSubProyectos",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.setState({
              todasSubProyectos: res.data.subProyectos,
              objetoSubProyectos: res.data.subProyectos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + " - " + value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      // Todos los tipos, tambien los deshabilitados: puede haber compras historicas
      // de proveedores con un tipo que ya se deshabilito.
      await axios
        .post(
          "tiposDeProveedores/selectTodosTiposDeProveedores",
          { empresaId: this.props.empresaId, valor: 3 },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (Array.isArray(res.data)) {
            this.setState({
              objetoTiposProveedor: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {`${value.nombre}${value.estado !== 1 ? " (Deshabilitado)" : ""}`}
                  </Option>
                );
              }),
            });
          }
        });
      this.consultarReporteCompras({
        periodo: [moment().subtract(1, "month"), moment()],
        proveedores: 0,
        filtrarProyecto: 0,
        estadoFacturas: 5,
      });
    }
  
    async crearGrafico(valueCompras, fechaInicial, fechaFinal) {
      let grafico = [];
      let graficoSumatoria = [];
      let sumatoria = 0;
  
      let fechaCambiante = moment(fechaInicial).locale("es");
      const fechaFinalMoment = moment(fechaFinal).locale("es");
  
      if (fechaFinalMoment.diff(fechaCambiante, "days") <= 31) {
        while (fechaFinalMoment.diff(fechaCambiante, "days") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "date"
              );
            } else {
              return false;
            }
          });
  
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("DD/MM/YYYY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "day").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "days") < 180) {
        while (fechaFinalMoment.diff(fechaCambiante, "weeks") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "week"
              );
            } else {
              return false;
            }
          });
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("[SEM] WW/YY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("[SEM] WW/YY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "week").locale("es");
        }
      } else if (fechaFinalMoment.diff(fechaCambiante, "months") < 36) {
        while (fechaFinalMoment.diff(fechaCambiante, "months") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "month"
              );
            } else {
              return false;
            }
          });
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("MM-YY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("MM-YY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "month").locale("es");
        }
      } else {
        while (fechaFinalMoment.diff(fechaCambiante, "years") !== -1) {
          // eslint-disable-next-line no-loop-func
          const compras = valueCompras.filter((todasCompras) => {
            if (isNaN(todasCompras.fechaFactura)) {
              return moment(fechaCambiante).isSame(
                moment(todasCompras.fechaFactura, "DD/MM/YYYY"),
                "year"
              );
            } else {
              return false;
            }
          });
          let totalPagar = 0;
  
          compras.map((valueCompraDia) => {
            totalPagar += valueCompraDia.totalPagar;
            return null;
          });
  
          grafico.push({
            x: moment(fechaCambiante).locale("es").format("YYYY"),
            y: totalPagar,
          });
  
          graficoSumatoria.push({
            x: moment(fechaCambiante).locale("es").format("YYYY"),
            y: totalPagar + sumatoria,
          });
  
          sumatoria += totalPagar;
          fechaCambiante = moment(fechaCambiante).add(1, "year").locale("es");
        }
      }
  
      await this.setState({
        dataGrafico: [
          {
            id: "Compras",
            color: "hsl(15, 70%, 50%)",
            data: grafico,
          },
          {
            id: "Compras Acumuladas",
            color: "hsl(15, 70%, 50%)",
            data: graficoSumatoria,
          },
        ],
      });
    }
  
    consultarReporteCompras(values) {
      this.setState({ loading: true });
      axios
        .post(
          "reportesDeCompras/reporteCompras",
          { ...values, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            this.crearGrafico(
              res.data.compras,
              res.data.fechaInicial,
              res.data.fechaFinal
            );
            this.setState({
              loading: false,
              dataReporte: res.data,
              todasCompras: res.data.compras,
              subtotal: res.data.subtotal,
              totalImpuestos: res.data.totalImpuestos,
              total: res.data.total,
              totalRetenciones: res.data.totalRetenciones,
              totalAPagar: res.data.totalAPagar,
              desglosarProductos: res.data.desglosarProductos,
            });
          } else if (res.data.success === 1) {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          } else {
            message.error("Ha sucedido un error y no se cargo bien el reporte");
          }
          this.setState({ loading: false });
        });
    }
  
    descargarExcel() {
      const border = {
        top: { style: "thin", color: { auto: 1 } },
        bottom: { style: "thin", color: { auto: 1 } },
        left: { style: "thin", color: { auto: 1 } },
        right: { style: "thin", color: { auto: 1 } },
      };
      const headerStyle = {
        font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "00BFD6" } },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
        border,
      };
      const cellStyle = { alignment: { vertical: "center" }, border };
      const moneyStyle = {
        alignment: { horizontal: "right", vertical: "center" },
        numFmt: '"$"#,##0.00',
        border,
      };
      const percentStyle = {
        alignment: { horizontal: "right", vertical: "center" },
        border,
      };

      const celda = (value, tipo) => {
        if (tipo === "money") {
          return { v: typeof value === "number" ? value : 0, s: moneyStyle };
        }
        if (tipo === "percent") {
          return {
            v: value === null || value === undefined ? "" : `${value}%`,
            s: percentStyle,
          };
        }
        return { v: value === null || value === undefined ? "" : value, s: cellStyle };
      };

      let datosDescargar = [];
      let columnasConfig = [];

      if (this.state.desglosarProductos) {
        columnasConfig = [
          { header: "Folio", key: "Folio", tipo: "texto" },
          { header: "Orden de compra", key: "Orden de compra", tipo: "texto" },
          { header: "Codigo Proveedor", key: "Codigo Proveedor", tipo: "texto" },
          { header: "Clave Proveedor", key: "Clave Proveedor", tipo: "texto" },
          { header: "Fecha", key: "Fecha", tipo: "texto" },
          { header: "Proveedor", key: "Proveedor", tipo: "texto" },
          { header: "RFC", key: "RFC", tipo: "texto" },
          { header: "Tipo de Proveedor", key: "Tipo de Proveedor", tipo: "texto" },
          { header: "Codigo Insumo", key: "Codigo Insumo", tipo: "texto" },
          { header: "Clave Insumo", key: "Clave Insumo", tipo: "texto" },
          { header: "Cantidad", key: "Cantidad", tipo: "texto" },
          { header: "Cantidad Inventario", key: "Cantidad Inventario", tipo: "texto" },
          { header: "Descripcion", key: "Descripcion", tipo: "texto" },
          { header: "Descripcion Interna", key: "Descripcion Interna", tipo: "texto" },
          { header: "Familia", key: "Familia", tipo: "texto" },
          { header: "Marca", key: "Marca", tipo: "texto" },
          { header: "Cuenta Inventario", key: "Cuenta Inventario", tipo: "texto" },
          { header: "Cuenta Costo/Gasto", key: "Cuenta Costo/Gasto", tipo: "texto" },
          { header: "Uso de CFDI", key: "Uso de CFDI", tipo: "texto" },
          { header: "Moneda", key: "Moneda", tipo: "texto" },
          { header: "Precio Unitario", key: "Precio Unitario", tipo: "money" },
          { header: "Descuento", key: "Descuento", tipo: "money" },
          { header: "% Descuento", key: "% Descuento", tipo: "percent" },
          { header: "Subtotal Insumo", key: "Subtotal Insumo", tipo: "money" },
          { header: "Precio Con Impuestos", key: "Precio Con Impuestos", tipo: "money" },
          { header: "Total Insumo", key: "Total Insumo", tipo: "money" },
          { header: "Fecha probable de pago", key: "Fecha probable de pago", tipo: "texto" },
          { header: "Fecha Vencimiento", key: "Fecha Vencimiento", tipo: "texto" },
        ];

        for (const valueCompra of this.state.todasCompras) {
          if (valueCompra.folio === "") {
            const compra = this.state.todasCompras.find(
              (todasCompras) =>
                todasCompras.folio !== "" &&
                todasCompras._id.toString() === valueCompra._id.toString()
            );
            datosDescargar.push({
              Folio: compra.folio,
              "Orden de compra": compra.serieOrdenCompra,
              "Codigo Proveedor": compra.codigoProveedor,
              "Clave Proveedor": compra.claveProveedor,
              Fecha: compra.fechaFactura,
              Proveedor: compra.proveedor,
              RFC: compra.proveedorRfc,
              "Tipo de Proveedor": compra.tipoProveedor,
              "Codigo Insumo": valueCompra.codigoProveedor,
              "Clave Insumo": valueCompra.claveProveedor,
              Cantidad: valueCompra.fechaFactura,
              "Cantidad Inventario": valueCompra.cantidadInventario,
              Descripcion: valueCompra.proveedor,
              "Descripcion Interna": valueCompra.descripcionInterna,
              Familia: valueCompra.familia,
              Marca: valueCompra.marca,
              "Cuenta Inventario": valueCompra.cuentaInventario,
              "Cuenta Costo/Gasto": valueCompra.cuentaCostoGasto,
              "Uso de CFDI": compra.usoDeCfdi,
              Moneda: compra.moneda,
              "Precio Unitario": valueCompra.total,
              Descuento: valueCompra.descuentoMonto,
              "% Descuento": valueCompra.descuentoPorcentaje,
              "Subtotal Insumo": valueCompra.totalPagado,
              "Precio Con Impuestos": valueCompra.saldo,
              "Total Insumo": valueCompra.estado,
              "Fecha probable de pago": compra.fechaPago,
              "Fecha Vencimiento": compra.fechaVencimiento,
            });
          }
        }
      } else {
        // La descripcion de un impuesto es texto libre: uno llamado "Total" pisaria
        // una columna fija, y un impuesto y una retencion pueden llamarse igual. Por
        // eso la llave interna va prefijada (el encabezado sigue siendo el nombre
        // limpio) y el de la retencion se desambigua solo cuando choca.
        const PREFIJO_IMPUESTO = "imp:";
        const PREFIJO_RETENCION = "ret:";
        const impuestosColumnas = [];
        const retencionesColumnas = [];
        this.state.todasCompras.forEach((valueCompra) => {
          if (Array.isArray(valueCompra.arrayImpuestos)) {
            valueCompra.arrayImpuestos.forEach((impuesto) => {
              const nombre = impuesto.descripcionFactura;
              if (nombre && !impuestosColumnas.includes(nombre))
                impuestosColumnas.push(nombre);
            });
          }
          if (Array.isArray(valueCompra.arrayRetenciones)) {
            valueCompra.arrayRetenciones.forEach((retencion) => {
              const nombre = retencion.descripcionFactura;
              if (nombre && !retencionesColumnas.includes(nombre))
                retencionesColumnas.push(nombre);
            });
          }
        });

        columnasConfig = [
          { header: "Folio", key: "Folio", tipo: "texto" },
          { header: "Orden de compra", key: "Orden de compra", tipo: "texto" },
          { header: "Codigo Proveedor", key: "Codigo Proveedor", tipo: "texto" },
          { header: "Clave Proveedor", key: "Clave Proveedor", tipo: "texto" },
          { header: "Fecha", key: "Fecha", tipo: "texto" },
          { header: "Proveedor", key: "Proveedor", tipo: "texto" },
          { header: "Razon Social", key: "Razon Social", tipo: "texto" },
          { header: "RFC", key: "RFC", tipo: "texto" },
          { header: "Tipo de Proveedor", key: "Tipo de Proveedor", tipo: "texto" },
          { header: "Fecha probable de pago", key: "Fecha probable de pago", tipo: "texto" },
          { header: "Total A Cobrar", key: "Total A Cobrar", tipo: "money" },
          { header: "Fecha Vencimiento", key: "Fecha Vencimiento", tipo: "texto" },
          { header: "Días Vencidos", key: "Días Vencidos", tipo: "texto" },
          { header: "Días de Crédito", key: "Días de Crédito", tipo: "texto" },
          { header: "Subtotal", key: "Subtotal", tipo: "money" },
          { header: "Impuestos", key: "Impuestos", tipo: "money" },
          { header: "Total", key: "Total", tipo: "money" },
          { header: "Retenciones", key: "Retenciones", tipo: "money" },
          { header: "Moneda", key: "Moneda", tipo: "texto" },
          { header: "Tipo de Cambio", key: "Tipo de Cambio", tipo: "texto" },
          { header: "Folio Fiscal", key: "Folio Fiscal", tipo: "texto" },
          { header: "Abonos", key: "Abonos", tipo: "money" },
          { header: "Saldo", key: "Saldo", tipo: "money" },
          { header: "Estado", key: "Estado", tipo: "texto" },
          { header: "Forma de Pago", key: "Forma de Pago", tipo: "texto" },
          { header: "Uso de CFDI", key: "Uso de CFDI", tipo: "texto" },
          { header: "Método de Pago", key: "Método de Pago", tipo: "texto" },
          ...impuestosColumnas.map((nombreImpuesto) => ({
            header: nombreImpuesto,
            key: PREFIJO_IMPUESTO + nombreImpuesto,
            tipo: "money",
          })),
          ...retencionesColumnas.map((nombreRetencion) => ({
            header: impuestosColumnas.includes(nombreRetencion)
              ? `Ret. ${nombreRetencion}`
              : nombreRetencion,
            key: PREFIJO_RETENCION + nombreRetencion,
            tipo: "money",
          })),
        ];

        datosDescargar = this.state.todasCompras.map((valueCompra) => {
          // Se acumula en vez de asignar: una factura puede traer dos entradas con
          // la misma descripcion (el alta desde XML las agrupa por impuestoId /
          // retencionId, no por descripcion). Y no se les suma ajusteImpuesto /
          // ajusteRetencion porque los montos ya se guardan con el ajuste dentro.
          let impuestosAgregar = {};
          if (Array.isArray(valueCompra.arrayImpuestos)) {
            valueCompra.arrayImpuestos.forEach((impuesto) => {
              const llave = PREFIJO_IMPUESTO + impuesto.descripcionFactura;
              impuestosAgregar[llave] = round2Decimals(
                (impuestosAgregar[llave] || 0) + (impuesto.totalImpuestos || 0)
              );
            });
          }
          if (Array.isArray(valueCompra.arrayRetenciones)) {
            valueCompra.arrayRetenciones.forEach((retencion) => {
              const llave = PREFIJO_RETENCION + retencion.descripcionFactura;
              impuestosAgregar[llave] = round2Decimals(
                (impuestosAgregar[llave] || 0) + (retencion.totalRetenciones || 0)
              );
            });
          }
          return {
            Folio: valueCompra.folio,
            "Orden de compra": valueCompra.serieOrdenCompra,
            "Codigo Proveedor": valueCompra.codigoProveedor,
            "Clave Proveedor": valueCompra.claveProveedor,
            Fecha: valueCompra.fechaFactura,
            Proveedor: valueCompra.proveedor,
            "Razon Social": valueCompra.razonSocial,
            RFC: valueCompra.proveedorRfc,
            "Tipo de Proveedor": valueCompra.tipoProveedor,
            "Fecha probable de pago": valueCompra.fechaPago,
            "Total A Cobrar": valueCompra.totalPagar,
            "Fecha Vencimiento": valueCompra.fechaVencimiento,
            "Días Vencidos": valueCompra.diasVencidos,
            "Días de Crédito": valueCompra.diasCredito,
            Subtotal: valueCompra.subtotal,
            Impuestos: valueCompra.impuestos,
            Total: valueCompra.total,
            Retenciones: valueCompra.retenciones,
            Moneda: valueCompra.moneda,
            "Tipo de Cambio": valueCompra.tipoCambio,
            "Folio Fiscal": valueCompra.folioFiscal,
            Abonos: valueCompra.totalPagado,
            Saldo: valueCompra.saldo,
            Estado: valueCompra.estado,
            "Forma de Pago": valueCompra.formaDePago,
            "Uso de CFDI": valueCompra.usoDeCfdi,
            "Método de Pago": valueCompra.metodoPago,
            ...impuestosAgregar,
          };
        });
      }

      const rows = [
        columnasConfig.map((columna) => ({ v: columna.header, s: headerStyle })),
        ...datosDescargar.map((fila) =>
          columnasConfig.map((columna) => celda(fila[columna.key], columna.tipo))
        ),
      ];

      const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = columnasConfig.map((columna) => ({
        wch: Math.max(columna.header.length + 2, 12),
      }));
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Reporte Compras");
      XLSXStyle.writeFile(workbook, "Reporte_Compras.xlsx");
    }
  
    descargarPdf() {
      pdfMake
        .createPdf(reporteDeComprasPdf(this.state.dataReporte))
        .download("Reporte Compras");
    }
  
    onFinishFailed(e) {
      ErrorItem(e);
    }
    render() {
      const columns = [
        {
          title: "Folio",
          dataIndex: "folio",
          key: "folio",
          sorter: (a, b) => {
            if (a.folio < b.folio) {
              return -1;
            }
            if (a.folio > b.folio) {
              return 1;
            }
            return 0;
          },
          buscar: "folio",
          ellipsis: true,
        },
        {
          title: "Fecha",
          dataIndex: "fechaFactura",
          key: "fechaFactura",
          sorter: (a, b) => {
            if (moment(a.fechaFactura, "DD/MM/YYYY") < moment(b.fechaFactura, "DD/MM/YYYY")) {
              return -1;
            }
            if (moment(a.fechaFactura, "DD/MM/YYYY") > moment(b.fechaFactura, "DD/MM/YYYY")) {
              return 1;
            }
            return 0;
          },
          buscar: "fechaFactura",
          ellipsis: true,
        },
        {
          title: "Proveedor",
          dataIndex: "proveedor",
          key: "proveedor",
          sorter: (a, b) => {
            if (a.proveedor < b.proveedor) {
              return -1;
            }
            if (a.proveedor > b.proveedor) {
              return 1;
            }
            return 0;
          },
          buscar: "proveedor",
          ellipsis: true,
        },
        {
          title: "RFC",
          dataIndex: "proveedorRfc",
          key: "proveedorRfc",
          sorter: (a, b) => {
            if (a.proveedorRfc < b.proveedorRfc) return -1;
            if (a.proveedorRfc > b.proveedorRfc) return 1;
            return 0;
          },
          buscar: "proveedorRfc",
          ellipsis: true,
        },
        {
          title: "Tipo de Proveedor",
          dataIndex: "tipoProveedor",
          key: "tipoProveedor",
          sorter: (a, b) => {
            if (a.tipoProveedor < b.tipoProveedor) return -1;
            if (a.tipoProveedor > b.tipoProveedor) return 1;
            return 0;
          },
          buscar: "tipoProveedor",
          ellipsis: true,
        },
        {
          title: "Vencimiento",
          dataIndex: "fechaVencimiento",
          key: "fechaVencimiento",
          sorter: (a, b) => {
            if (moment(a.fechaVencimiento, "DD/MM/YYYY") < moment(b.fechaVencimiento, "DD/MM/YYYY")) {
              return -1;
            }
            if (moment(a.fechaVencimiento, "DD/MM/YYYY") > moment(b.fechaVencimiento, "DD/MM/YYYY")) {
              return 1;
            }
            return 0;
          },
          buscar: "fechaVencimiento",
          ellipsis: true,
        },
        {
          title: "Precio Unitario",
          dataIndex: "total",
          key: "precioUnitario",
          ellipsis: true,
          render: (value, record) => (record.folio === "" ? dineroDisabledMask(value) : ""),
          align: "right",
        },
        {
          title: "Descuento",
          dataIndex: "descuentoMonto",
          key: "descuentoMonto",
          ellipsis: true,
          render: (value, record) => (record.folio === "" ? dineroDisabledMask(value) : ""),
          align: "right",
        },
        {
          title: "% Descuento",
          dataIndex: "descuentoPorcentaje",
          key: "descuentoPorcentaje",
          ellipsis: true,
          render: (value, record) => (record.folio === "" ? `${value}%` : ""),
          align: "right",
        },
        {
          title: "Total",
          dataIndex: "total",
          key: "total",
          sorter: (a, b) => {
            if (a.total < b.total) {
              return -1;
            }
            if (a.total > b.total) {
              return 1;
            }
            return 0;
          },
          buscar: "total",
          render: (value, record) => (record.folio === "" ? "" : dineroDisabledMask(value)),
          align: "right",
          ellipsis: true,
        },
        {
          title: "Abonos",
          dataIndex: "totalPagado",
          key: "totalPagado",
          sorter: (a, b) => {
            if (a.totalPagado < b.totalPagado) {
              return -1;
            }
            if (a.totalPagado > b.totalPagado) {
              return 1;
            }
            return 0;
          },
          buscar: "totalPagado",
          ellipsis: true,
          render: (value, record) => (record.folio === "" ? "" : dineroDisabledMask(value)),
          align: "right",
        },
        {
          title: "Saldo",
          dataIndex: "saldo",
          key: "saldo",
          sorter: (a, b) => {
            if (a.saldo < b.saldo) {
              return -1;
            }
            if (a.saldo > b.saldo) {
              return 1;
            }
            return 0;
          },
          buscar: "saldo",
          ellipsis: true,
          render: (value, record) => (record.folio === "" ? "" : dineroDisabledMask(value)),
          align: "right",
        },
        {
          title: "Estado",
          dataIndex: "estado",
          key: "estado",
          sorter: (a, b) => {
            if (a.estado < b.estado) {
              return -1;
            }
            if (a.estado > b.estado) {
              return 1;
            }
            return 0;
          },
          buscar: "estado",
          ellipsis: true,
        },
        {
          title: "Forma de Pago",
          dataIndex: "formaDePago",
          key: "formaDePago",
          sorter: (a, b) => {
            if (a.formaDePago < b.formaDePago) return -1;
            if (a.formaDePago > b.formaDePago) return 1;
            return 0;
          },
          buscar: "formaDePago",
          ellipsis: true,
        },
        {
          title: "Uso de CFDI",
          dataIndex: "usoDeCfdi",
          key: "usoDeCfdi",
          sorter: (a, b) => {
            if (a.usoDeCfdi < b.usoDeCfdi) return -1;
            if (a.usoDeCfdi > b.usoDeCfdi) return 1;
            return 0;
          },
          buscar: "usoDeCfdi",
          ellipsis: true,
        },
        {
          title: "Método de Pago",
          dataIndex: "metodoPago",
          key: "metodoPago",
          sorter: (a, b) => {
            if (a.metodoPago < b.metodoPago) return -1;
            if (a.metodoPago > b.metodoPago) return 1;
            return 0;
          },
          buscar: "metodoPago",
          ellipsis: true,
        },
      ];
      return (
        <>
          <Form
            ref={this.formRef}
            name="rerpoteCompras"
            onFinish={this.consultarReporteCompras.bind(this)}
            onFinishFailed={this.onFinishFailed}
            initialValues={{
              periodo: [moment().subtract(1, "month"), moment()],
            }}
          >
            <PageHeader
              onBack={this.atras.bind(this)}
              title="Reporte Compras"
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
              extra={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarExcel()}
                        icon={<FileExcelOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                    {this.state.dataReporte && (
                      <ButtonItem
                        blanco
                        onClick={() => this.descargarPdf()}
                        icon={<FilePdfOutlined />}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Descargar PDF
                      </ButtonItem>
                    )}
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Consultar
                    </ButtonItem>
                  </Space>
                </div>
              }
            />
            <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
                <Tabs
                  style={{ margin: 0 }}
                  tabBarExtraContent={{
                    left: (
                      <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                        Filtros:
                      </h1>
                    ),
                  }}
                >
                  <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                    <FormItem name="periodo" required noStyle>
                      <RangePickerItem />
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                    <FormItem name="proveedores" noStyle margin>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Proveedores"
                      >
                        {this.state.objetoProveedores}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="7" key="7" forceRender tab="Tipo de Proveedor">
                    <FormItem name="tiposProveedor" noStyle margin>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Tipos de Proveedor"
                        allowClear
                      >
                        {this.state.objetoTiposProveedor}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                    <Row>
                      <Col span={8}>
                        <FormItem
                          name="filtrarProyecto"
                          required
                          noStyle
                          initialValue={0}
                        >
                          <SelectItem width="90%" placeholder="Filtrar Proyecto">
                            <Option default value={0}>
                              Niguno
                            </Option>
                            <Option value={1}>Proyectos</Option>
                            <Option value={2}>Unidades de negocio</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const filtrarProyecto =
                              getFieldValue("filtrarProyecto");
                            if (filtrarProyecto === 1) {
                              return (
                                <FormItem required name="proyectos" margin noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Proyectos"
                                    mode="multiple"
                                  >
                                    {this.state.objetoProyectos}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                            if (filtrarProyecto === 2) {
                              return (
                                <FormItem required margin name="unidadDeNegocioId" noStyle>
                                  <SelectItem
                                    width="90%"
                                    placeholder="Unidades de Negocio"
                                  >
                                    {this.state.objetoUniadesDeNegocio}
                                  </SelectItem>
                                </FormItem>
                              );
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabKey="6" key="6" forceRender tab="Subproyecto">
                    <FormItem name="subProyectos" noStyle margin>
                      <SelectItem
                        width="90%"
                        mode="multiple"
                        placeholder="Subproyectos"
                        allowClear
                      >
                        {this.state.objetoSubProyectos}
                      </SelectItem>
                    </FormItem>
                  </TabPane>
                  <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                    <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                      <Col span={8}>
                        <FormItem
                          label="Estado"
                          name="estadoFacturas"
                          required
                          initialValue={5}
                          style={{ marginBottom: 0 }}
                        >
                          <SelectItem placeholder="Filtrar Por">
                            <Option default value={5}>
                              Todos
                            </Option>
                            <Option value={4}>Por Pagar</Option>
                            <Option value={3}>Pagada</Option>
                            <Option value={2}>Vencida</Option>
                            <Option value={1}>Canceladas</Option>
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem
                          label="Desglosar Productos"
                          name="desglosarProductos"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        {/* <FormItem
                          label="Detalle"
                          name="detalle"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem> */}
                      </Col>
                    </Row>
                  </TabPane>
                </Tabs>
              </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 35,
                marginTop: 10,
                marginBottom: 10,
                height: 420,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Gráfico</h1>

              <ResponsiveLine
                data={this.state.dataGrafico}
                margin={{ top: 15, right: 20, bottom: 70, left: 100 }}

                // ✅ Tooltips tipo “línea vertical” (mucho más claro)
                enableSlices="x"
                useMesh={true}

                yFormat={(e) => dineroDisabledMask(Math.abs(e))}

                xScale={{ type: "point" }}
                yScale={{
                  type: "linear",
                  min: 0,
                  max: "auto",
                  stacked: false,
                  reverse: false,
                }}

                curve="monotoneX"
                lineWidth={2}

                // ✅ Menos ruido visual
                pointSize={5}
                pointBorderWidth={1}
                pointColor={{ theme: "background" }}
                pointBorderColor={{ from: "serieColor" }}

                // Si quieres aún más limpio, descomenta:
                // enablePoints={false}

                colors={["#ff6633", "#FF926E"]}
                colorBy="index"

                axisTop={null}
                axisRight={null}

                axisBottom={{
                  tickSize: 5,
                  tickPadding: 8,
                  tickRotation: 45,
                  // ✅ muestra menos etiquetas (una de cada 2 o 3)
                  tickValues: (this.state.dataGrafico?.[0]?.data || [])
                    .map(d => d.x)
                    .filter((_, i) => i % 2 === 0),
                }}

                axisLeft={{
                  tickSize: 5,
                  tickPadding: 8,
                  format: (v) => dineroDisabledMask(Math.abs(v)),
                }}

                // ✅ Grid más limpio
                enableGridX={false}

                legends={[
                  {
                    anchor: "top-right",
                    direction: "column",
                    translateX: 0,
                    translateY: 0,
                    itemWidth: 130,
                    itemHeight: 18,
                    symbolSize: 10,
                    symbolShape: "circle",
                    itemOpacity: 0.85,
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "75px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
                <Row>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Subtotal</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.subtotal)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>+</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Impuestos</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.totalImpuestos)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>=</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Total</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.total)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>-</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Retenciones</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.totalRetenciones)}
                    </h1>
                  </Col>
                  <Col span={1} style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: 20 }}>=</h1>
                  </Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    <p style={{ margin: 0 }}>Total A Pagar</p>
                    <h1 style={{ fontSize: 15 }}>
                      {dineroDisabledMask(this.state.totalAPagar)}
                    </h1>
                  </Col>
                </Row>
              </div>
              <TableItem
                // onRow={(record, rowIndex) => {
                //   return {
                //     onDoubleClick: (event) => {
                //       this.props.history.push("/panel/verVenta", {
                //         id: record._id,
                //       });
                //     },
                //   };
                // }}
                rowKey={(value) => value._id.toString() + Math.random()}
                columns={columns}
                dataSource={this.state.todasCompras}
                size="small"
                pagination={false}
              />
              {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
            </Spin>
          </Form>
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
    };
  };
  
  export default connect(mapStateToProps)(ReporteCompras);
  